if (!customElements.get('youtube-player')) {
  customElements.define('youtube-player', class YoutubePlayerElement extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
  
      document.querySelectorAll('[data-modal-video-link]').forEach((element) => {
        element.addEventListener('click', (e) => {
          e.preventDefault();
  
          const videoUrl = element.getAttribute('data-modal-video-src');
  
          const videoId = this.getYouTubeVideoId(videoUrl);
  
          this.renderPlayer(videoId);
        });
      });
    }
  
    renderPlayer(videoId) {
      if (document.getElementById('youtube-player-overlay')) return;
      const overlay = document.createElement('div');
      overlay.id = 'youtube-player-overlay';
  
      document.body.appendChild(overlay);
      document.body.style.overflow = 'hidden';
  
      const closeButton = document.querySelector('#youtubeCloseIcon');
  
      closeButton.className = '';
      closeButton.style.display = 'inline';
  
      const playerContainer = document.createElement('div');
      playerContainer.id = 'youtubePlayerContainer';
     
      overlay.appendChild(closeButton);
      overlay.appendChild(playerContainer);
  
      document.body.appendChild(overlay);
      document.body.appendChild(closeButton);
  
      if (typeof YT !== 'undefined' && YT && YT.Player) {
        this.createYouTubePlayer(playerContainer, videoId);
      } else {
        window.onYouTubeIframeAPIReady = () => {
          this.createYouTubePlayer(playerContainer, videoId);
        };
      }
  
      closeButton.addEventListener('click', () => {
        document.body.style.overflow = '';
  
        if (overlay && overlay.parentNode === document.body) {
          document.body.removeChild(overlay);
        }
        closeButton.style.display = 'none';
      });
    }
  
    createYouTubePlayer(container, videoId) {
      new YT.Player(container, {
        videoId: videoId,
        playerVars: {
          autoplay: 1,
          controls: 1,
          modestbranding: 1,
          rel: 0,
          playsinline: 1,
        },
        events: {
          onReady: (event) => event.target.playVideo(),
        },
      });
    }
  
    getYouTubeVideoId(url) {
      const urlObj = new URL(url);
      const videoId = urlObj.searchParams.get('v');
      if (!videoId) {
        const splitString = url.split('/');
        return splitString[splitString.length - 1];
      }
      return videoId;
    }
  });
}
